import { render, staticRenderFns } from "./createResourcePopup.vue?vue&type=template&id=dc3c7060&"
import script from "./createResourcePopup.vue?vue&type=script&lang=js&"
export * from "./createResourcePopup.vue?vue&type=script&lang=js&"
import style0 from "./popups.less?vue&type=style&index=0&module=popup&lang=css&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["popup"] = (style0.locals || style0)
        Object.defineProperty(this, "popup", {
          configurable: true,
          get: function () {
            return cssModules["popup"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./popups.less?vue&type=style&index=0&module=popup&lang=css&"], function () {
          var oldLocals = cssModules["popup"]
          if (oldLocals) {
            var newLocals = require("./popups.less?vue&type=style&index=0&module=popup&lang=css&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["popup"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("dc3c7060")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc3c7060')) {
      api.createRecord('dc3c7060', component.options)
    } else {
      api.reload('dc3c7060', component.options)
    }
    module.hot.accept("./createResourcePopup.vue?vue&type=template&id=dc3c7060&", function () {
      api.rerender('dc3c7060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/resources/components/popups/createResourcePopup.vue"
export default component.exports